export default __webpack_public_path__ + "static/DSC_0027-cd833b58cfc8f40b9ab10bb157a38c04.jpg";